import "./style.css";
import React, { lazy, Suspense, useState } from "react";
import Particles from "../Particles/Particles";
import ieltsThinkingImage from "../../assets/ietls-thinking.webp";
import TestForm from "../../Components/TestForm";

const Modal = lazy(() => import("../../Components/Modal/Modal"));

const IELTS = () => {
  const [showModal, setShowModal] = useState(false);

  const getProficiencyLevel = (score) => {
    const levels = {
      9: "Expert User",
      8: "Very Good User",
      7: "Good User",
      6: "Competent User",
      5: "Modest User",
      4: "Limited User",
      3: "Extremely Limited User",
      2: "Intermittent User",
      1: "Non-User",
    };
    return levels[score];
  };

  return (
    <>
      <Particles title="Know About IELTS" subTitle="Information in IELTS" />
      <div className="ielts-information container">
        <div className="row">
          <div className="col-md-6 col-12 about-ielts">
            <h2>What is IELTS?</h2>
            <p>
              The International English Language Testing System (IELTS) is a
              globally recognized English proficiency test designed for
              individuals who want to study, work, or migrate to
              English-speaking countries. It is accepted by over 11,000
              organizations worldwide, including universities, employers, and
              immigration authorities.
            </p>
          </div>
          <div className="col-md-6 d-none d-md-block">
            <div className="image-container">
              <img src={ieltsThinkingImage} alt="ielts-image" />
            </div>
          </div>
        </div>
        <div className="row justify-content-between px-0">
          <div className="col-12 col-lg-9">
            <div className="test-format">
              <h2>Test Format & Sections</h2>
              <p>The IELTS test consists of four sections:</p>
              <ol>
                <li>
                  <strong className="sub-heading">Listening</strong>
                  <ul>
                    <li>
                      <strong>Duration:</strong> 30 minutes (+10 minutes to
                      transfer answers if paper-based).
                    </li>
                    <li>
                      <strong>Format:</strong> 4 recorded conversations and
                      monologues.
                    </li>
                    <li>
                      <strong>Questions:</strong> 40 questions covering
                      multiple-choice, matching, map/diagram labeling, and
                      sentence completion.
                    </li>
                  </ul>
                </li>
                <br />
                <li>
                  <strong className="sub-heading">Reading</strong>
                  <ul>
                    <li>
                      <strong>Duration:</strong> 60 minutes.
                    </li>
                    <li>
                      <strong>Format:</strong>
                      <ul>
                        <li>
                          <strong>Academic:</strong> 3 long, complex texts from
                          books, journals, and newspapers.
                        </li>
                        <li>
                          <strong>General Training:</strong> 3 sections with
                          shorter, real-life texts from advertisements, notices,
                          and company handbooks.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Questions:</strong> 40 questions including
                      multiple-choice, true/false/not given, and matching
                      headings.
                    </li>
                  </ul>
                </li>
                <br />
                <li>
                  <strong className="sub-heading">Writing</strong>
                  <ul>
                    <li>
                      <strong>Duration:</strong> 60 minutes.
                    </li>
                    <li>
                      <strong>Format:</strong>
                      <ul>
                        <li>
                          <strong>Academic:</strong>
                          <ul>
                            <li>
                              <strong>Task 1:</strong> Describe a graph, chart,
                              or diagram (150 words).
                            </li>
                            <li>
                              <strong>Task 2:</strong> Essay writing (250
                              words).
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>General Training:</strong>
                          <ul>
                            <li>
                              <strong>Task 1:</strong> Write a letter
                              (formal/informal).
                            </li>
                            <li>
                              <strong>Task 2:</strong> Essay writing (250
                              words).
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <br />
                <li>
                  <strong className="sub-heading">Speaking</strong>
                  <ul>
                    <li>
                      <strong>Duration:</strong> 11–14 minutes.
                    </li>
                    <li>
                      <strong>Format:</strong> A face-to-face interview with an
                      examiner.
                      <ul>
                        <li>
                          <strong>Part 1:</strong> Introduction & general
                          questions (4–5 mins).
                        </li>
                        <li>
                          <strong>Part 2:</strong> Cue card topic (1 min
                          preparation, 2 mins speaking).
                        </li>
                        <li>
                          <strong>Part 3:</strong> Discussion based on Part 2
                          topic (4–5 mins).
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
            <br />
            <div className="scoring-system">
              <h2>Scoring System</h2>
              <p>
                IELTS is scored on a band scale of 1 to 9. Each section
                (Listening, Reading, Writing, Speaking) is given a band score.
                The overall band score is the average of the four sections.
              </p>
              <br />

              <table className="table">
                <thead>
                  <tr className="table-head">
                    <th>Band Score</th>
                    <th>Proficiency Level</th>
                  </tr>
                </thead>
                <tbody>
                  {[9, 8, 7, 6, 5, 4, 3, 2, 1].map((score) => (
                    <tr key={score}>
                      <td className={`band-score-${score}`}>{score}</td>
                      <td className={`band-score-${score}`}>
                        {getProficiencyLevel(score)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-6 col-lg-3 mt-3 my-lg-4 align-items-start d-flex">
            <div className="register-card">
              <h1>Take IELTS Class</h1>
              <button
                type="button"
                className="btn btn-md join-button"
                onClick={() => setShowModal(true)}
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Suspense fallback={<></>}>
          <Modal
            showModal={showModal}
            setShowModal={setShowModal}
            header="Join IELTS"
          >
            <TestForm setShowModal={setShowModal} preferredClass="IELTS" />
          </Modal>
        </Suspense>
      )}
    </>
  );
};

export default IELTS;
